export default __webpack_public_path__ + "static/media/Banner2.91a2d681.png";